// DS: C44
/** Popover showing information about a hovered user */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import UserAvatarPopoverContent from './UserAvatarPopoverContent';
import { ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { withLogBiEvent } from '@wix/da-bi/pkg/hocs/withLogBiEvent';
import UserAvatarPopoverButtonsContext from './UserAvatarPopoverButtonsContext';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiContext, BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import SimpleHoverPopperPopover from '@wix/da-ds/pkg/popper/presets/SimpleHoverPopperPopover';
import s from './UserAvatarPopover.scss';
const HOVER_DELAY = 500;
export const UserAvatarPopover = (props)=>{
    const { data, isError, isOwner, isLoading, children, className, isMobile, relatedItemBiData } = props;
    const PopoverContent = ()=>{
        const biContext = useContext(BiContext);
        const withButtons = useContext(UserAvatarPopoverButtonsContext);
        if (isError || !data) {
            return null;
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['tooltip'], (!withButtons || isOwner) && s['without-buttons'])
        }, !isError && data && /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
            value: {
                widgetname: 'user_popup',
                sectionname: biContext.sectionname && `${biContext.sectionname}_popup`
            }
        }, /*#__PURE__*/ React.createElement(UserAvatarPopoverContent, _object_spread({
            withButtons: !isOwner && withButtons,
            relatedItemBiData: relatedItemBiData
        }, data))));
    };
    const onVisible = ()=>{
        if (props.biData) {
            props.logBiEvent(props.biData);
        }
        if (!props.isInitialized) {
            props.initialize(props.username);
        }
    };
    if (isMobile) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
    return /*#__PURE__*/ React.createElement(SimpleHoverPopperPopover, {
        className: classnames(s['popover-root'], isLoading && s['loading'], className),
        contentClassName: s['tooltip-content'],
        arrowClassName: s['tooltip-arrow'],
        popoverContent: /*#__PURE__*/ React.createElement(PopoverContent, null),
        noPadding: true,
        hoverDelay: HOVER_DELAY,
        isVisible: !!data,
        onVisible: onVisible,
        showArrow: false,
        forceTheme: ThemeOptions.DARK
    }, children);
};
export default compose(withMobileContext, withLogBiEvent)(UserAvatarPopover);
